import { Stack, VStack, Box } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components/'
import { BookTitle } from '@!/Store/Common/components/ListItem'
import { RankingCrown, ScrollableContent } from '@!/Store/Home/components'
import { isBlank } from '@!/Util'

/* 横スクロール型のランキングリスト */
export const ScrollableRankingList = ({ rankings, tabName }) => {
  const getSectionTitle = (rankingType) => {
    switch (rankingType) {
      case 'total':
        return '総合コミックランキング'
      case 'boy':
        return '少年コミックランキング'
      case 'man':
        return '青年コミックランキング'
      case 'girl':
        return '少女コミックランキング'
      case 'lady':
        return '女性向けコミックランキング'
      case 'media':
        return 'メディア化作品ランキング'
      case 'amazia':
        return 'マンガBANGオリジナル作品ランキング'
      default:
        return 'ランキング'
    }
  }

  return (
    <Stack spacing={4}>
      {rankings.map((ranking) => {
        if (isBlank(ranking.titles)) return null

        const sectionTitle = getSectionTitle(ranking.ranking_type)
        const url = ranking.ranking_type === 'total' ? '/store/rankings' : `/store/rankings?ranking_type=${ranking.ranking_type}`

        const items = ranking.titles.map((title, index) => {
          return (
            <VStack key={`ranking-${index}-${title.title_id}`} spacing={0} mr={3}>
              <BookTitle title={title.title_name} titleId={title.title_id} imageUrl={title.image_url} sectionTitle={`${tabName}_${sectionTitle}`} w="100px" />
              <RankingCrown ranking={index + 1} />
            </VStack>
          )
        })

        return (
          <Stack key={`ranking-section-${ranking.ranking_type}`} spacing={0} mr={4}>
            <Box ml={4}>
              <SectionTitle title={sectionTitle} url={url} tabName={tabName} />
            </Box>
            <ScrollableContent>
              <Stack direction="row" spacing={0} ml={4}>
                {items}
              </Stack>
            </ScrollableContent>
          </Stack>
        )
      })}
    </Stack>
  )
}
